import React from 'react';
import IndividualChallenge from './IndividualChallenge';
import { Spinner } from '@amzn/awsui-components-react/polaris';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
  return { user: (state.appState && state.appState.user) ? state.appState.user : "nobody" }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
}


class IndividualChallengeWrapper extends React.Component {
  render(){
    if(this.props.user === "nobody"){
      return(
        <Spinner size="large"></Spinner>
      )
    }
    return(
        <div id='individual_table_container'>
            <IndividualChallenge {...this.props}/>
        </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IndividualChallengeWrapper);



// WEBPACK FOOTER //
// ./src/app/components/IndividualChallengeWrapper.jsx